import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';

import { requiredWhenPresent } from '../../shared/propTypes';
import { PeriodPropTypes } from '../../shared/propTypes/period';
import { TaxAccountingPropTypes } from '../../shared/propTypes/taxAccounting';

const DeleteTaxAccountingModal = ({
  period,
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isVisible,
  isRemovingInProgress,
}) => {
  const removeTaxAccounting = useCallback(() => {
    removeEntity({ ...entityToRemove, periodName: period.name }, { rowIndex });
  }, [removeEntity, entityToRemove, period, rowIndex]);

  return (
    <Modal
      className="delete-tax-accounting-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Tax Accounting"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeTaxAccounting}
      isVisible={isVisible}
      isSubmitting={isRemovingInProgress}
    >
      { entityToRemove
        ? (
          <div>
            Are you sure you want to delete: <br/><br/>
            Tax Description: {entityToRemove.taxDescription}<br/>
            Period: {period.name}<br/><br/>
          </div>
        )
        : null
      }
    </Modal>
  );
};

DeleteTaxAccountingModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  period: PeriodPropTypes.isRequired,
  entityToRemove: requiredWhenPresent(['isVisible'], TaxAccountingPropTypes),
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
  isRemovingInProgress: PropTypes.bool.isRequired,
};

export default DeleteTaxAccountingModal;
